import React, { useContext, useState } from 'react';
import './login.css';
import { useTranslation } from 'react-i18next';
import DataContext from '../../context/Datacontext';
import useWindowSize from '../../hooks/useWindowSize';
import loginpage from '../../images/Logingpage.svg';
import loginpageAR from '../../images/LoginpageAR.svg';

import axios from '../../api/DataTrans';
import { Link, useNavigate } from 'react-router-dom';
// import io from 'socket.io-client';
const Login = () => {
    // const socket = io.connect("https://way-go.vercel.app/");
    const navigate = useNavigate();
    const {lang,setUserProfile,setToken} = useContext(DataContext);
    const [t] = useTranslation("global");
    const {width} = useWindowSize();
    const [phone,setPhone] = useState('');
    const [otp,setOtp] = useState('');
    const [hash,setHash] = useState('');
    const [validatCode,setValidateCode] = useState('');
    const [validate,setValidate] = useState(false);
    const handelLogin = async () => {
        if(phone.length === 10 ){
            try{
                const response = await axios.post('/customer/getCode',{
                    'phoneNumber':phone,
                  },
                  {
                    headers:{
                      'Content-Type' : 'application/json'
                    },
                  },
                  );
                //   alert(lang?'تم ارسال الرسالة بنجاح':'the request is sent');
                //   setPhone('');
                  setValidate(true);
                  setOtp(response.data.otp);
                  setHash(response.data.data);
                  console.log(response);
            }
            catch(err){
                console.log(err);
            }
        }
        else{
            alert(lang?'ادخل رقم جوال صحيح':'insert a valid phone number please')
        }
    }
    const handlevalidation = async () => {
        if(validatCode.length === 4){
            try{
                const response = await axios.post('/customer/checkPhoneCode',{
                    'phoneNumber':phone,
                    'otp':validatCode,
                    'hash':hash
                  },
                  {
                    headers:{
                      'Content-Type' : 'application/json'
                    },
                  },
                  );
                //   alert(lang?'تم ارسال الرسالة بنجاح':'the request is sent');
                //   setPhone('');
                  setValidate(false);
                  console.log(response);
                  setToken(response.data.token);
                  setUserProfile(response.data.profile);
                  navigate('/search');
            }
            catch(err){
                alert(lang?'كود التفعيل ليس صحيحاً':'the validation code is not true');
                console.log(err);
            }
        }
        else{
            alert(lang?'كود التفعيل ليس صحيحاً':'the validation code is not true');
        }
    }
  return (
    <div className='login_main' style={{
            // justifyContent:lang ? width > 600 ? 'flex-end' : 'center' : width > 600 ? 'flex-end' :  'center',
            flexDirection:lang ? width > 1000 ? 'row' : 'column' : width > 1000 ? 'row-reverse' :  'column',
            paddingTop:width < 1000 ? "100px":'0px',paddingBottom:width < 1000 ? "100px":'0px'
            }}>
        <div className='login_container_box'
             style={{
                // marginLeft:!lang && width > 1000 ? '50px' : '0px',marginRight:lang && width > 1000 ? '70px' : '0px',
                    //  marginTop:width<1000 ?'50px':'0px',
                     flexDirection:width<425?'column':'row',
                     marginLeft:width > 1000 && !lang?'0px':'50px',marginRight:width > 1000 && lang?'0px':'50px',
             }}
        >
            <div className='login_box_1'>
                {!lang && <img src={loginpage} alt='' style={{width:width<=1000 ? "80%" : "100%"}}/>}
                {lang && <img src={loginpageAR} alt='' style={{width:width<=1000 ? "80%" : "100%"}}/>}
            </div>
        </div>
        <div className='login_container' 
             style={{marginLeft:width > 600 && !lang?'100px':'0px',marginRight:width > 600 && lang?'100px':'0px',
                     justifyContent:lang?'flex-end':'flex-start',marginTop:width<1000 ? '45px':'0px'}}>
            <div className='login_h1' style={{alignItems:lang?'flex-end':'flex-start'}}>
                <p className='login_para'>{t("login.login")}</p>
            </div>
            <div className='login_h2' style={{alignItems:lang?'flex-end':'flex-start',marginTop:'10px',marginBottom:'10px'}}>
                <p className='login_para'>{t("login.youdont")}</p>
                <p className='login_para'>{t("login.youdont1")} <span><Link to='/signup' className='login_para' style={{textDecoration:'none',color:'rgb(20,138,117)'}} > {t("login.signup")}</Link></span></p>
                
            </div>
                <div className='login_h2' style={{alignItems:lang?'flex-end':'flex-start'}}>
                    <p className='login_para'>{t("login.phone")}</p>
                    <input className='loginInput' type='text'maxLength={10} minLength={10} required onChange={(e) => setPhone(e.target.value)} value={phone}
                        style={{textAlign:lang?'right':'left',paddingLeft:!lang?'5px':'0px',paddingRight:lang ? '5px':'0px'}}
                    />
                </div>
                <div className='login_h3' style={{justifyContent:lang?'flex-end':'flex-start'}}>
                    <button onClick={handelLogin} className='login_sign'>{t("login.logbutton")}</button>
                </div>
        </div>
        <div className='validate' style={{display:validate?'flex':'none'}}>
            <div className='validate_box'>
                <div className='login_h2' style={{alignItems:lang?'flex-end':'flex-start',marginTop:'10px',marginBottom:'10px'}}>
                    <p className='login_para'>{t("login.validate")}</p>
                    <p className='login_para'>{t("login.validate1")}</p>
                    <p className='login_para'>{otp}</p>

                </div>
                <input className='loginInput' type='text' maxLength={4} required onChange={(e) => setValidateCode(e.target.value)} value={validatCode}
                        style={{textAlign:'center',paddingLeft:!lang?'5px':'0px',paddingRight:lang ? '5px':'0px',marginTop:'30px',}}
                    />
                    <button onClick={handlevalidation} className='login_sign' style={{marginTop:'50px'}}>{t("login.check")}</button>
                    <button onClick={() => setValidate(false)} className='exit' >X</button>
            </div>
        </div>
    </div>
  )
}

export default Login